import { NextPageContext } from 'next';

import ListCollection from 'types/redux/ListCollection';

import Article, { Roles } from 'models/Article';

import { list as listArticles, single } from 'requests/articles';

import Component from './component';
import { Props } from './types';

Component.getInitialProps = async (appContext: NextPageContext): Promise<Props> => {
    let article: Article;
    let tutorials: ListCollection<Article>;

    try {
        await Promise.all([
            single({ slug: appContext?.query?.slug.toString() }),
            listArticles({ role: Roles.Worker, page: 1, perPage: 6, categorySlug: 'szkolenia' }),
        ]).then(responses => {
            article = responses[0];
            tutorials = responses[1];
        });
    } catch (error) {
        console.error(error);
        return {
            notFound: true,
        };
    }

    return {
        tutorials: tutorials.elements || null,
        article,
    };
};

export default Component;
